import React from "react";
import RadicalLineBackground from "../components/RadicalLineBackground";
import Partnership from "../components/Partnership";

const About = () => {
  return (
    <section className="overflow-hidden relative mx-auto my-0 w-full min-h-screen bg-white">
      <div className="flex relative gap-20 px-11 pt-44 pb-0 max-md:flex-col max-md:gap-10 max-md:px-8 max-md:pt-32 max-md:pb-0 max-sm:px-6 max-sm:pt-20 max-sm:pb-0">
        <RadicalLineBackground />
        <h1 className="relative z-10 mb-10 text-5xl tracking-tighter leading-[108%] max-w-[70%] text-stone-900 max-md:text-[40px] max-sm:text-[24px] max-md:mb-10 max-sm:pt-80 max-sm:leading-[1.15] max-sm:w-[80%] max-sm:tracking-tighter">
          OpenMind is building the first open, decentralized ecosystem for
          real-world robotics and AI collaboration.
        </h1>
      </div>

      <div className="flex justify-end m-40 max-md:m-20 max-md:pl-12 max-sm:pl-8 max-sm:my-0 max-sm:w-[80%]">
        <div className="relative text-2xl leading-[108%] max-w-[70%] font-creato max-md:max-w-full max-md:text-[18px] max-sm:hidden">
          <p>
            Our open-source platform, OM1, is an LLM-powered runtime that equips
            robots and digital agents with multimodal intelligence, enabling
            them to perceive, plan, and act autonomously. Alongside OM1, we’ve
            developed FABRIC, a global machine network where robots, devices,
            and humans cooperate securely via a P2P communication network,
            on-chain identities, and algorithmic tasking.
            <br />
            <br />
            Together, OM1 and FABRIC dismantle proprietary silos in robotics. We
            provide developers and institutions with the tools to deploy robots
            across diverse hardware platforms, incentivize data/knowledge
            sharing between machines, and incentivize robotic
            fine-tuning/improvements at massive scale.
          </p>
        </div>

        <div className="relative leading-[108%] font-creato text-[18px] mr-5 sm:hidden">
          <p>
            Our open-source platform, OM1, is an LLM-powered runtime that equips
            robots and digital agents with multimodal intelligence, enabling
            them to perceive, plan, and act autonomously.
            <br />
            <br />
            Alongside OM1, we’ve developed FABRIC, a global machine network
            where robots, devices, and humans cooperate securely via a P2P
            communication network, on-chain identities, and algorithmic tasking.
            <br />
            <br />
            Together, OM1 and FABRIC dismantle proprietary silos in robotics. We
            provide developers and institutions with the tools to deploy robots
            across diverse hardware platforms, incentivize data/knowledge
            sharing between machines, and incentivize robotic
            fine-tuning/improvements at massive scale.
          </p>
        </div>
      </div>

      <h1
        className="text-[52px] tracking-tighter leading-[108%] text-stone-900 lg:w-[60%] w-[70%] px-11 max-md:max-w-full max-md:px-8 max-md:text-[40px] max-sm:pt-20 max-sm:px-6 max-sm:text-[24px] max-sm:w-[80%] max-sm:leading-[1.15]"
        id="vision"
      >
        We believe intelligence is <wbr />
        shared,&nbsp;not&nbsp;isolated.
      </h1>

      <div className="flex justify-end m-40 max-md:m-20 max-md:mb-40 max-md:pl-12 max-sm:pl-8 max-sm:w-[80%]">
        <div className="relative text-2xl leading-[108%] max-w-[70%] font-creato max-md:max-w-full max-md:text-[18px] max-sm:text-[18px] max-sm:mr-5">
          <p>
            Our end-goal is to power a new era of robotics: one reshaped by mass
            collaboration, continuous feedback, and equitable access. We see a
            future where anyone, anywhere, can build intelligent systems, share
            insights, and access powerful tools that grow stronger together. Not
            a closed model—but a shared platform for collective progress.
          </p>
        </div>
      </div>

      <Partnership />
    </section>
  );
};

export default About;
